import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const HttpRequestWidget: WidgetRegistryEntry = {
  name: "HttpRequest",
  component: () => import("./http-request-widget.component").then((m) => m.HttpRequestWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.HttpRequestWidgetConfiguration)
};
